<template>
    <div class="loading-icon">
        <div v-if="type === 'bars'" class="loading-icon__content loading-icon__content--bars">
            <div :style="barStyle" />
            <div :style="barStyle" />
            <div :style="barStyle" />
        </div>

        <div v-if="type === 'dots'" class="loading-icon__content loading-icon__content--dots">
            <div :style="dotStyle" />
            <div :style="dotStyle" />
            <div :style="dotStyle" />
            <div :style="dotStyle" />
        </div>

        <div v-if="type === 'spinner'" class="loading-icon__content loading-icon__content--spinner">
            <div :style="spinnerStyle" />
            <div :style="spinnerStyle" />
            <div :style="spinnerStyle" />
            <div :style="spinnerStyle" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'loading-icon',

    props: {
        type: {
            type: String,
            default: 'dots',
        },

        color: {
            type: String,
            default: '#2c3e50',
        },
    },

    computed: {
        barStyle() {
            return { backgroundColor: this.color };
        },

        dotStyle() {
            return { background: this.color };
        },

        spinnerStyle() {
            return { borderColor: `${ this.color } transparent transparent transparent` };
        },
    },
};
</script>

<style lang="scss">
.loading-icon {
    width: 64px;
    height: 64px;

    &__content {
        display: inline-block;
        position: relative;
        width: 100%;
        height: 100%;

        &--bars {
            div {
                display: inline-block;
                position: absolute;
                left: 6px;
                width: 13px;
                animation: loading-icon-bars 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;

                &:nth-child(1) {
                    left: 6px;
                    animation-delay: -0.24s;
                }

                &:nth-child(2) {
                    left: 26px;
                    animation-delay: -0.12s;
                }

                &:nth-child(3) {
                    left: 45px;
                    animation-delay: 0;
                }
            }
        }

        &--dots {
            div {
                position: absolute;
                top: 27px;
                width: 11px;
                height: 11px;
                border-radius: 50%;
                animation-timing-function: cubic-bezier(0, 1, 1, 0);

                &:nth-child(1) {
                    left: 6px;
                    animation: loading-icon-dots-1 0.6s infinite;
                }

                &:nth-child(2) {
                    left: 6px;
                    animation: loading-icon-dots-2 0.6s infinite;
                }

                &:nth-child(3) {
                    left: 26px;
                    animation: loading-icon-dots-2 0.6s infinite;
                }

                &:nth-child(4) {
                    left: 45px;
                    animation: loading-icon-dots-3 0.6s infinite;
                }
            }
        }

        &--spinner {
            div {
                box-sizing: border-box;
                display: block;
                position: absolute;
                width: 51px;
                height: 51px;
                margin: 6px;
                border: 6px solid;
                border-radius: 50%;
                animation: loading-icon-spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;

                &:nth-child(1) {
                    animation-delay: -0.45s;
                }
                &:nth-child(2) {
                    animation-delay: -0.3s;
                }
                &:nth-child(3) {
                    animation-delay: -0.15s;
                }
            }
        }
    }
}

@keyframes loading-icon-bars {
    0% {
        top: 6px;
        height: 51px;
    }

    50%, 100% {
        top: 19px;
        height: 26px;
    }
}

@keyframes loading-icon-dots-1 {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes loading-icon-dots-2 {
    0% {
        transform: translate(0, 0);
    }

    100% {
        transform: translate(19px, 0);
    }
}

@keyframes loading-icon-dots-3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}

@keyframes loading-icon-spinner {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
